import uuidV4 from 'lib/string/uuidV4Utils'
import { CHECKOUT_ITEM_TYPE_LOYALTY_PURCHASE_POINTS } from 'constants/checkout'

export function generateLoyaltyPurchasePointsItem(
  offer: App.LoyaltyPurchasePointsOffer,
): App.Checkout.LoyaltyPurchasePointsItem {
  return {
    itemType: CHECKOUT_ITEM_TYPE_LOYALTY_PURCHASE_POINTS,
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    offerId: offer.id,
    title: offer.title,
    points: offer.basePoints,
    bonusPoints: offer.bonusPoints,
    currencyCode: offer.currency,
    basePrice: offer.basePrice,
    price: offer.publicPrice,
    total: offer.publicPrice,
  }
}
